import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { get } from 'lodash';
import createStore from './store';
import App from './containers/App';
import ErrorBoundary from './containers/ErrorBoundary';
import { resetState } from './actions/rootActions';

const store = createStore();

function WeatherApp(props) {
  const { fieldId } = props;
  const storeFieldId = get(store.getState(), 'field.id', null);
  const [readyFieldId, setReadyFieldId] = useState(
    storeFieldId === fieldId ? fieldId : null
  );

  useEffect(() => {
    if (get(store.getState(), 'field.id', null) !== fieldId) {
      store.dispatch(resetState());
    }
    setReadyFieldId(fieldId);
  }, [fieldId]);

  return (
    <ErrorBoundary key={fieldId}>
      <Provider store={store}>
        {readyFieldId === fieldId ? <App {...props} /> : null}
      </Provider>
    </ErrorBoundary>
  );
}

WeatherApp.propTypes = {
  fieldId: PropTypes.string,
  userId: PropTypes.number,
};

export default WeatherApp;
